angular.module('access.Nodes')
    .constant('NOTARY_APP_EVENT', {
        CLOSE: 'notaryApp.close'
    })
    .directive('accNotaryApp', [
        'NOTARY_ANNOTATION_STATUS',
        'NOTARY_APP_EVENT',
        'NotaryAnnotation',
        (NOTARY_ANNOTATION_STATUS, NOTARY_APP_EVENT, NotaryAnnotation) => ({
            replace: true,
            restrict: 'E',
            scope: {
                onAnnotationCancel: '&',
                onAnnotationError: '&',
                onAnnotationSuccess: '&',
                pdf: '<',
                url: '<'
            },
            template: `
            <iframe
                id="notary-app"
                ng-src="{{ url }}"
                sandbox="allow-scripts allow-same-origin"
            >
            </iframe>
            `,
            link: ($scope, $element) => {
                const notaryAppInstance = NotaryAnnotation.initNewApp($element.get(0), $scope.url);

                notaryAppInstance.on(NOTARY_ANNOTATION_STATUS.SUCCESS, $scope.onAnnotationSuccess);
                notaryAppInstance.on(NOTARY_ANNOTATION_STATUS.CANCEL, $scope.onAnnotationCancel);
                notaryAppInstance.on(NOTARY_ANNOTATION_STATUS.ERROR, $scope.onAnnotationError);

                $scope.$on(NOTARY_APP_EVENT.CLOSE, () => notaryAppInstance.close());
                $scope.$on('$destroy', () => notaryAppInstance.destroy());

                $element.on('load', () => notaryAppInstance.sendFile($scope.pdf));
            }
        })
    ]);
